import { render, staticRenderFns } from "./SurveyItem.vue?vue&type=template&id=d971d25c&scoped=true&"
import script from "./SurveyItem.vue?vue&type=script&lang=ts&"
export * from "./SurveyItem.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyItem.vue?vue&type=style&index=0&id=d971d25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d971d25c",
  null
  
)

export default component.exports